import API from 'services/api';

const api = new API();

const URL_PARTNER_PROFILE = '/api/partner-profile/';
const URL_PARTNER_PROFILE_LOGO = '/api/partner-profile/logo/';

class PartnerInformationAPI {
    getPartnerProfile() {
        return new Promise((resolve, reject) => {
            api.getJson(URL_PARTNER_PROFILE, {
                method: 'GET',
                credentials: 'include',
            })
                .then(response => {
                    if (response.status !== 0) return reject(response.value);
                    return resolve(response.value);
                })
                .catch(reject);
        });
    }

    updatePartnerProfile(data) {
        return new Promise((resolve, reject) => {
            api.getJson(URL_PARTNER_PROFILE, {
                method: 'PATCH',
                credentials: 'include',
                body: data,
            })
                .then(response => {
                    if (response.status !== 0) return reject(response.value);
                    return resolve(response.value);
                })
                .catch(reject);
        });
    }

    validatePartnerWebsite(website) {
        return new Promise((resolve, reject) => {
            api.getJson(`${URL_PARTNER_PROFILE}validate-website/`, {
                method: 'POST',
                credentials: 'include',
                body: { website },
            })
                .then(response => {
                    if (response.status !== 0) return reject(response.value);
                    return resolve(response.value);
                })
                .catch(reject);
        });
    }

    uploadPartnerLogo(file) {
        return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append('logo', file);

            api.getJson(URL_PARTNER_PROFILE_LOGO, {
                method: 'POST',
                credentials: 'include',
                body: formData,
                fixErr: true,
            })
                .then(response => {
                    if (response.status !== 0) return reject(response.value);
                    return resolve(response.value);
                })
                .catch(reject);
        });
    }
}

export default new PartnerInformationAPI();
